module.exports = __webpack_public_path__ + "static/img/ls17.1572df7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark2/ls17.png
// module id = Eybc
// module chunks = 12